<template>
  <div class="container albums">
    <AlbumCard v-for="album in albumsSorted" :key="album.slug" :album="album" />
  </div>

  <ClientOnly>
    <Teleport to="#teleport">
      <input
        v-model="filterText"
        type="text"
        placeholder="Search..."
        class="px-4 py-1 border rounded-2xl focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
    </Teleport>
  </ClientOnly>
</template>

<script lang="ts" setup>
import type { Album } from "~/api";

const api = useApi();
const config = useRuntimeConfig();

const filterText = ref<string>();

useHead({
  title: () => config.public.SITE_NAME,
});

const { data: albums } = await useAsyncData<Album[]>(
  () => api.albums.getAlbums(),
  {
    default: () => [],
    server: false,
  }
);

const albumsFiltered = computed(() => {
  const _value = filterText.value;

  return _value
    ? albums.value.filter((item) =>
        item.title.toLowerCase().includes(_value.toLowerCase())
      )
    : albums.value;
});

const albumsSorted = computed(() => {
  return [...albumsFiltered.value].sort((a, b) => {
    const startDateA = a.startDate ?? "";
    const startDateB = b.startDate ?? "";
    return startDateB.localeCompare(startDateA);
  });
});
</script>

<style lang="postcss">
.albums {
  @apply grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 p-1;
}
</style>
